<template>
  <div>
    <vs-prompt
      title="Add venue to sync account"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Venue</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-select
                autocomplete
                label="Search for venue..."
                v-model="newVenueSelect"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.name"
                  v-for="(item, index) in userVenues"
                />
              </vs-select>
            </div>
          </div>
          <div class="vx-row mb-6" v-if="newVenueSelect">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Email</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Search for venue to fill"
                v-model="newVenueSelect.email"
              />
              <p>
                <br />If {{ newVenueSelect.email }} is an alias of a Google
                Group, the <strong>primary mail</strong> will be added instead.
              </p>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      newVenueSelect: null,
      syncAccount: "",
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userVenues: "venues/venues",
    }),
    validForm() {
      return (
        this.newVenueSelect !== null &&
        this.newVenueSelect.email &&
        this.newVenueSelect.email !== ""
      );
    },
  },
  methods: {
    show(syncAccount) {
      this.syncAccount = syncAccount;
      this.newVenueSelect = null;
      this.prompt = true;
    },
    async accept() {
      const dto = {
        venueEmail: this.newVenueSelect.email,
        venueId: this.newVenueSelect.venueId,
        venueName: this.newVenueSelect.name,
        syncEmail: this.syncAccount,
      };

      this.$vs.loading();

      await this.$store.dispatch("email/addSyncVenue", dto);

      this.$vs.notify({
        color: "success",
        title: `Venue added`,
        text: "Venue added",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
